import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ApiEndpoints, FrontEndPoints } from '../shared/Common';
import Api from '../shared/Api';
import './ForgotPassword.scss';
import { Row, Col } from 'antd';
import history from "../shared/history";
import { useTranslation, Trans } from 'react-i18next';

const ForgotPassword = (props: any) => {

    const [email, setEmail] = useState("");
    const [isPasswordChanged, setIsPasswordChanged] = useState("");
    const [isError, setIsError] = useState("");
    const { t, i18n } = useTranslation();

    const sendEmail = (): void => {

        if (!email.length || !email.length) {
            setIsError("please write email correctly!");
            return;
        }

        setIsError("");

        Api.post(ApiEndpoints.UserAccount.ResetPasswordWithToken, { email: email }).then(response => {
            setIsError("");
            setIsPasswordChanged("Email has been sent to your registered email address with reset password link!");
        }, err => {
            setIsPasswordChanged("");
            setIsError("Error occurred");
        });
    }

    return (
        <div className="forgot-password">
            <Row className="main">
                <Col className="forgot-signin">

                    <h3 className="title">{t("ForgotPassword")}</h3>
                    <div className="credentials-group">
                       
                        <div className="form-group">                           
                            <input type="text" value={email} onChange={event => setEmail(event.target.value)} className="user-input" id="email" placeholder="Email" />
                            <span className="sub-text">{t("sendLinkWereTouCanResetYourPassword")}</span>
                        </div>

                        <div className="form-group">
                            <span className="sub-text">{isPasswordChanged}</span>
                            <span className="sub-text">{isError}</span>
                        </div>
                        
                        <div className="form-group">
                            <div className="buttons">
                                <button className="sendlink-btn" onClick={sendEmail}>
                                    {t("SendLink")}
                                </button>
                            </div>
                        </div>
                       
                    </div>
                </Col>

                <Col className="forgot-signup">
                    <div className="caption">
                        <span>{t("RememberPassword?")}</span>
                    </div>
                    <div className="buttons">
                        <Link className="login-link" to={FrontEndPoints.login}>{t("logIn")}</Link>
                    </div>
                </Col>
            </Row>
        </div>
    );
}

export default ForgotPassword;